var map = {
	"./webspecial_food_sushi_cn.webm": 7229,
	"./webspecial_food_sushi_de.webm": 7255,
	"./webspecial_food_sushi_en.webm": 2895,
	"./webspecial_food_sushi_ja.webm": 3421,
	"./webspecial_food_sushi_tr.webm": 954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8603;